import { useQueryClient } from '@tanstack/react-query'
import type { ColumnMapping } from '@/components/ExcelExportModal'

export const DAY_OFF_TYPE = [
    { label: 'annual_leave', value: 'annual_leave' },
    { label: 'normal', value: 'normal' },
]

export const DAY_OFF_STATUS = [
    { label: 'pending', value: 'pending' },
    { label: 'leader-approved', value: 'leader-approved' },
    { label: 'cancelled', value: 'cancelled' },
    { label: 'rejected', value: 'rejected' },
    { label: 'approved', value: 'approved' },
]

export const useRefetchDayOffQueries = () => {
    const queryClient = useQueryClient()

    const refetchAll = async () => {
        await Promise.all([
            queryClient.invalidateQueries({ queryKey: ['workday-list'] }),
            queryClient.invalidateQueries({ queryKey: ['dayoffs-member'] }),
            queryClient.invalidateQueries({ queryKey: ['dayoffs-hrm'] }),
        ])
    }

    return { refetchAll }
}

export const DAYOFF_EXCEL_COLUMNS: ColumnMapping[] = [
    { header: 'day_off_id', data_field: 'day_off_id' },
    { header: 'employee_name', data_field: 'employee_name' },
    { header: 'department_name', data_field: 'department_name' },
    { header: 'position', data_field: 'position_name' },
    {
        header: 'day_off_type',
        data_field: 'day_off_type',
        formatter_type: 'translate',
    },
    {
        header: 'day_off_status',
        data_field: 'day_off_status',
        formatter_type: 'translate',
    },
    { header: 'number_of_day_off', data_field: 'number_of_day_off' },
    { header: 'day_off_reason', data_field: 'day_off_reason' },
    { header: 'day_off_note', data_field: 'day_off_note' },
    {
        header: 'day_off_created_at',
        data_field: 'day_off_created_at',
        formatter_type: 'date',
        formatter_options: { date_format: 'DD/MM/YYYY HH:mm' },
    },
    {
        header: 'leader',
        data_field: 'day_off_leader_confirmed',
        formatter_type: 'boolean',
    },
    { header: 'day_off_feedback_lead', data_field: 'day_off_feedback_lead' },
    { header: 'day_off_leader_name', data_field: 'day_off_leader_name' },
    {
        header: 'day_off_leader_confirmed_at',
        data_field: 'day_off_leader_confirmed_at',
        formatter_type: 'date',
        formatter_options: { date_format: 'DD/MM/YYYY HH:mm' },
    },
    {
        header: 'bom/bod',
        data_field: 'day_off_bod_confirmed',
        formatter_type: 'boolean',
    },
    { header: 'day_off_feedback_bod', data_field: 'day_off_feedback_bod' },
    { header: 'day_off_bod_name', data_field: 'day_off_bod_name' },
    {
        header: 'day_off_bod_confirmed_at',
        data_field: 'day_off_bod_confirmed_at',
        formatter_type: 'date',
        formatter_options: { date_format: 'DD/MM/YYYY HH:mm' },
    },
]
